import React from 'react';
import { motion } from 'framer-motion';
import { Check, Plus, ArrowRight } from 'lucide-react';
export function ServicesSection() {
  return <section className="py-24 bg-white" id="planes" data-id="element-410">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-411">
        <div className="text-center mb-16" data-id="element-412">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl lg:text-5xl font-serif text-inkova-primary mb-6" data-id="element-413">
            Elige tu punto de partida.
          </motion.h2>
          <p className="text-xl text-gray-600 font-light mb-8" data-id="element-414">
            No hay un camino único. Hay el camino correcto para ti.
          </p>
          <div className="w-24 h-1 bg-inkova-accent mx-auto rounded-full" data-id="element-415"></div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mb-20 rounded-2xl overflow-hidden shadow-lg max-w-5xl mx-auto" data-id="element-416">
          <img src="https://cdn.magicpatterns.com/uploads/rojTV54FnSaLdwaFZYfqdJ/ChatGPT_Image_Apr_1,_2026,_05_00_05_PM.png" alt="Consultoría de negocios en Inkova" className="w-full h-64 md:h-96 object-cover" data-id="element-417" />
        </motion.div>

        <div className="grid lg:grid-cols-3 gap-8 mb-20" data-id="element-418">
          {/* Plan 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-inkova-light rounded-3xl p-8 border border-inkova-accent/20 flex flex-col h-full" data-id="element-419">
            <div className="mb-6" data-id="element-420">
              <h3 className="text-xl font-serif font-bold text-inkova-primary mb-2 uppercase tracking-wider" data-id="element-421">
                PLAN 1
              </h3>
              <h4 className="text-2xl font-bold text-inkova-dark mb-4" data-id="element-422">
                Creación de Empresa en EE.UU.
              </h4>
              <div className="text-4xl font-bold text-inkova-primary mb-4" data-id="element-423">
                $520
              </div>
              <div className="text-sm text-gray-700 space-y-1" data-id="element-424">
                <p className="font-medium" data-id="element-425">
                  Servicio Inkova:{' '}
                  <span className="text-inkova-primary font-bold" data-id="element-426">$390</span>
                </p>
                <p className="font-medium" data-id="element-427">
                  Fee estatal Florida:{' '}
                  <span className="text-inkova-primary font-bold" data-id="element-428">$130</span>
                </p>
                <p className="text-xs text-gray-500 italic mt-2" data-id="element-429">
                  Transparencia total: el fee estatal se paga directamente
                  al&nbsp;gobierno.
                </p>
              </div>
            </div>

            <div className="space-y-6 flex-grow" data-id="element-430">
              <div data-id="element-431">
                <h5 className="font-bold text-inkova-dark mb-3" data-id="element-432">
                  Registro y documentación:
                </h5>
                <ul className="space-y-2" data-id="element-433">
                  <li className="flex items-start text-sm text-gray-700" data-id="element-434">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-435" />
                    Registro LLC en Florida
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-436">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-437" />
                    Obtención de EIN
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-438">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-439" />
                    Presentación ante Sunbiz
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-440">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-441" />
                    Confirmación oficial de documentos
                  </li>
                </ul>
              </div>

              <div data-id="element-442">
                <h5 className="font-bold text-inkova-dark mb-3" data-id="element-443">
                  Estructura y acompañamiento:
                </h5>
                <ul className="space-y-2" data-id="element-444">
                  <li className="flex items-start text-sm text-gray-700" data-id="element-445">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-446" />
                    Sesión estratégica de claridad
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-447">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-448" />
                    Definición básica del modelo de negocio
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-449">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-450" />
                    Guía de organización inicial
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-451">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-452" />
                    Asesoría para apertura de cuenta bancaria
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-453">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-454" />
                    Paso a paso de cumplimiento inicial
                  </li>
                </ul>
              </div>

              <div data-id="element-455">
                <h5 className="font-bold text-inkova-dark mb-3" data-id="element-456">
                  Lo que te entregamos:
                </h5>
                <ul className="space-y-2" data-id="element-457">
                  <li className="flex items-start text-sm text-gray-700" data-id="element-458">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-459" />
                    Checklist completo del proceso
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-460">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-461" />
                    Documentación requerida
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-462">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-463" />
                    Guía: qué hacer después de crear la empresa
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-464">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-465" />
                    Responsabilidades anuales explicadas
                  </li>
                </ul>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-inkova-accent/20" data-id="element-466">
              <p className="text-xs text-gray-500 mb-4" data-id="element-467">
                Registered Agent no incluido. Inkova gestiona y coordina el
                proceso de registro. No somos un despacho de abogados.
              </p>
              <div className="bg-white p-4 rounded-xl text-sm font-medium text-inkova-dark text-center shadow-sm mb-4" data-id="element-468">
                No es solo crear una empresa. Es empezar con estructura.
              </div>
              <a href="https://inkovacreation.store/shop/7f390a19-9be8-4bef-be02-00a79bcf09f8" target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-inkova-primary text-white font-bold py-3 rounded-xl hover:bg-inkova-dark transition-colors" data-id="element-469">
                Quiero este plan
              </a>
            </div>
          </motion.div>

          {/* Plan 3 - Highlighted */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-inkova-primary text-white rounded-3xl p-8 shadow-2xl relative transform lg:-translate-y-4 flex flex-col h-full border-2 border-inkova-accent" data-id="element-470">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-inkova-accent text-inkova-primary font-bold px-6 py-2 rounded-full text-sm uppercase tracking-wider shadow-lg" data-id="element-471">
              Recomendado
            </div>

            <div className="mb-6 mt-4" data-id="element-472">
              <h3 className="text-xl font-serif font-bold text-inkova-accent mb-2 uppercase tracking-wider" data-id="element-473">
                PLAN 3
              </h3>
              <h4 className="text-2xl font-bold text-white mb-3" data-id="element-474">
                Inkova Full Creation ⭐
              </h4>
              <div className="text-4xl font-bold text-white mb-1" data-id="element-475">$1,490</div>
              <div className="flex items-center justify-start gap-3 mb-3" data-id="element-476">
                <span className="text-lg text-gray-400 line-through font-medium" data-id="element-477">
                  $1,490
                </span>
                <span className="text-2xl font-bold text-inkova-accent" data-id="element-478">
                  $1,192
                </span>
                <span className="bg-[#C9A84C]/20 text-[#C9A84C] text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full" data-id="element-479">
                  20% OFF
                </span>
              </div>
              <div className="bg-white/5 border border-white/15 rounded-lg px-4 py-2.5 mb-3" data-id="element-480">
                <p className="text-xs text-gray-300 mb-1" data-id="element-481">
                  Usa el código al momento del pago:
                </p>
                <p className="text-sm font-bold text-white tracking-widest" data-id="element-482">
                  INKOVA30
                </p>
              </div>
              <p className="text-[11px] text-gray-400 italic" data-id="element-483">
                Oferta por tiempo limitado
              </p>
              <p className="text-sm text-gray-300 italic mt-3" data-id="element-484">
                La solución completa para el emprendedor que quiere salir listo,
                no en proceso.
              </p>
            </div>

            <div className="space-y-6 flex-grow" data-id="element-485">
              <div data-id="element-486">
                <h5 className="font-bold text-inkova-accent mb-3" data-id="element-487">
                  Lo que incluye:
                </h5>
                <ul className="space-y-4" data-id="element-488">
                  <li className="flex items-start text-sm text-gray-200" data-id="element-489">
                    <Plus className="w-5 h-5 text-inkova-accent mr-3 flex-shrink-0" data-id="element-490" />
                    <span data-id="element-491">
                      <strong data-id="element-492">Todo el Plan 1</strong>
                      <br data-id="element-493" />
                      (empresa registrada y en orden)
                    </span>
                  </li>
                  <li className="flex items-start text-sm text-gray-200" data-id="element-494">
                    <Plus className="w-5 h-5 text-inkova-accent mr-3 flex-shrink-0" data-id="element-495" />
                    <span data-id="element-496">
                      <strong data-id="element-497">Todo el Plan 2</strong>
                      <br data-id="element-498" />
                      (presencia digital lista)
                    </span>
                  </li>
                  <li className="flex items-start text-sm text-gray-200" data-id="element-499">
                    <Plus className="w-5 h-5 text-inkova-accent mr-3 flex-shrink-0" data-id="element-500" />
                    <span data-id="element-501">
                      <strong data-id="element-502">Integración completa</strong>
                      <br data-id="element-503" />
                      entre estructura y presencia
                    </span>
                  </li>
                  <li className="flex items-start text-sm text-gray-200" data-id="element-504">
                    <Plus className="w-5 h-5 text-inkova-accent mr-3 flex-shrink-0" data-id="element-505" />
                    <span data-id="element-506">
                      <strong data-id="element-507">Dominio profesional</strong>
                      <br data-id="element-508" />
                      tu nombre de marca en la web
                    </span>
                  </li>
                  <li className="flex items-start text-sm text-gray-200" data-id="element-509">
                    <Plus className="w-5 h-5 text-inkova-accent mr-3 flex-shrink-0" data-id="element-510" />
                    <span data-id="element-511">
                      <strong data-id="element-512">Email corporativo</strong>
                      <br data-id="element-513" />
                      correo profesional con tu dominio
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-white/20" data-id="element-514">
              <div className="bg-white/10 p-4 rounded-xl text-sm font-medium text-white text-center backdrop-blur-sm mb-6" data-id="element-515">
                Sales con tu negocio listo. No con una empresa en papel y una
                idea en la cabeza.
              </div>
              <a href="https://inkovacreation.store/shop/c4aa0400-b53a-4a2b-a3b1-b8dc6c49dc79" target="_blank" rel="noopener noreferrer" className="w-full block text-center bg-inkova-accent text-inkova-primary font-bold py-4 rounded-xl hover:bg-white transition-colors text-lg" data-id="element-516">
                Este es mi plan
              </a>
            </div>
          </motion.div>

          {/* Plan 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="bg-inkova-light rounded-3xl p-8 border border-inkova-accent/20 flex flex-col h-full" data-id="element-517">
            <div className="mb-6" data-id="element-518">
              <h3 className="text-xl font-serif font-bold text-inkova-primary mb-2 uppercase tracking-wider" data-id="element-519">
                PLAN 2
              </h3>
              <h4 className="text-2xl font-bold text-inkova-dark mb-3" data-id="element-520">
                Diseño profesional de landing pages
              </h4>
              <div className="text-4xl font-bold text-inkova-primary mb-1" data-id="element-521">
                $990
              </div>
              <div className="flex items-center gap-3 mb-3" data-id="element-522">
                <span className="text-lg text-gray-400 line-through font-medium" data-id="element-523">
                  $990
                </span>
                <span className="text-2xl font-bold text-inkova-primary" data-id="element-524">
                  $792
                </span>
                <span className="bg-[#C9A84C]/20 text-[#C9A84C] text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full" data-id="element-525">
                  20% OFF
                </span>
              </div>
              <div className="bg-inkova-primary/5 border border-inkova-primary/15 rounded-lg px-4 py-2.5 mb-3" data-id="element-526">
                <p className="text-xs text-gray-500 mb-1" data-id="element-527">
                  Usa el código al momento del pago:
                </p>
                <p className="text-sm font-bold text-inkova-primary tracking-widest" data-id="element-528">
                  LAUNCH30
                </p>
              </div>
              <p className="text-[11px] text-gray-400 italic" data-id="element-529">
                Oferta por tiempo limitado · Ideal para lanzar tu presencia
                digital
              </p>
              <p className="text-sm text-gray-600 italic mt-3" data-id="element-530">
                Para el emprendedor que necesita presencia digital clara,
                profesional y lista para convertir.
              </p>
            </div>

            <div className="space-y-6 flex-grow" data-id="element-531">
              <div data-id="element-532">
                <h5 className="font-bold text-inkova-dark mb-3" data-id="element-533">
                  Lo que incluye:
                </h5>
                <ul className="space-y-2" data-id="element-534">
                  <li className="flex items-start text-sm text-gray-700" data-id="element-535">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-536" />
                    Landing page informativa (1 página)
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-537">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-538" />
                    Copy estratégico adaptado a tu servicio o producto
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-539">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-540" />
                    Estructura enfocada en conversión
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-541">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-542" />
                    Diseño alineado a tu identidad
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-543">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-544" />
                    Lista para recibir clientes desde el día 1
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-545">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-546" />
                    Dominio profesional — tu nombre de marca en la&nbsp;web
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-547">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-548" />
                    Email corporativo — correo profesional con tu&nbsp;dominio
                  </li>
                </ul>
              </div>
            </div>

            <div className="mt-6 pt-6 border-t border-inkova-accent/20" data-id="element-549">
              <p className="text-xs text-gray-500 mb-4" data-id="element-550">
                Este plan incluye únicamente 1 página. Si necesitas web
                completa, tienda online o funciones adicionales → se cotiza
                según alcance.
              </p>
              <div className="bg-white p-4 rounded-xl text-sm font-medium text-inkova-dark text-center shadow-sm mb-4 italic" data-id="element-551">
                "No necesitas una web grande. Necesitas una web clara que
                convierta."
              </div>
              <a href="https://inkovacreation.store/shop/0a4a199b-ffee-460f-99fb-e38d1c6da17d" target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-inkova-primary text-white font-bold py-3 rounded-xl hover:bg-inkova-dark transition-colors" data-id="element-552">
                Quiero este plan
              </a>
            </div>
          </motion.div>
        </div>

        {/* Add-ons Table */}
        <div id="servicios-adicionales" className="max-w-4xl mx-auto" data-id="element-553">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-554">
            <div className="bg-inkova-light p-6 border-b border-gray-200" data-id="element-555">
              <h4 className="text-2xl font-serif font-bold text-inkova-primary text-center" data-id="element-556">
                SERVICIOS ADICIONALES
              </h4>
            </div>
            <div className="overflow-x-auto" data-id="element-557">
              <table className="w-full text-left border-collapse" data-id="element-558">
                <thead data-id="element-559">
                  <tr className="bg-gray-50 text-gray-600 text-sm uppercase tracking-wider" data-id="element-560">
                    <th className="p-4 font-medium border-b border-gray-200" data-id="element-561">
                      Servicio
                    </th>
                    <th className="p-4 font-medium border-b border-gray-200" data-id="element-562">
                      Inversión
                    </th>
                  </tr>
                </thead>
                <tbody className="text-gray-800" data-id="element-563">
                  <tr className="border-b border-gray-100 hover:bg-gray-50 transition-colors" data-id="element-564">
                    <td className="p-4 font-medium" data-id="element-565">Annual Report (Sunbiz)</td>
                    <td className="p-4 text-inkova-primary font-bold" data-id="element-566">
                      $150 / año{' '}
                      <span className="text-xs text-gray-500 font-normal" data-id="element-567">
                        (fee estatal no incluido)
                      </span>
                    </td>
                  </tr>
                  <tr className="border-b border-gray-100 hover:bg-gray-50 transition-colors" data-id="element-568">
                    <td className="p-4 font-medium" data-id="element-569">Logo profesional</td>
                    <td className="p-4 text-inkova-primary font-bold" data-id="element-570">$300</td>
                  </tr>
                  <tr className="border-b border-gray-100 hover:bg-gray-50 transition-colors" data-id="element-571">
                    <td className="p-4 font-medium" data-id="element-572">Notaría</td>
                    <td className="p-4 text-inkova-primary font-bold" data-id="element-573">
                      $15 – $25
                    </td>
                  </tr>
                  <tr className="border-b border-gray-100 hover:bg-gray-50 transition-colors" data-id="element-574">
                    <td className="p-4 font-medium" data-id="element-575">
                      Membresía Inkova Web Care
                    </td>
                    <td className="p-4 text-inkova-primary font-bold" data-id="element-576">$50</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="p-6 border-t border-gray-200 text-center" data-id="element-577">
              <a href="https://wa.me/17863037695?text=Hola%2C%20quiero%20informaci%C3%B3n%20sobre%20los%20servicios%20adicionales%20de%20Inkova" target="_blank" rel="noopener noreferrer" className="inline-block bg-inkova-primary text-white font-bold py-3 px-8 rounded-xl hover:bg-inkova-dark transition-colors text-base" data-id="element-578">
                Solicitar este servicio
              </a>
            </div>
          </motion.div>

          {/* Guía Digital — Ruta USA 360 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mt-12 bg-gradient-to-br from-[#5a4579] to-[#3A2558] rounded-3xl p-8 md:p-10 shadow-2xl border border-inkova-accent/30 text-white relative overflow-hidden" data-id="element-579">
            {/* Decorative glow */}
            <div className="absolute -top-20 -right-20 w-60 h-60 bg-inkova-accent rounded-full opacity-10 blur-3xl" data-id="element-580"></div>

            <div className="relative z-10 flex flex-col md:flex-row gap-8 items-center" data-id="element-581">
              {/* Left: Icon / Visual */}
              <div className="flex-shrink-0 w-40 md:w-52" data-id="element-582">
                <img src="https://cdn.magicpatterns.com/uploads/hgsVwhPwjC7s256g1UbNn5/Guia_practica_para_negocios_en_EE.UU..png" alt="Guía Digital — Ruta USA 360" className="w-full h-auto object-contain rounded-xl shadow-lg" data-id="element-583" />
              </div>

              {/* Right: Content */}
              <div className="flex-grow text-center md:text-left" data-id="element-584">
                <span className="inline-block bg-inkova-accent/20 text-inkova-accent text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full mb-4" data-id="element-585">
                  Descargable instantáneo
                </span>

                <h4 className="text-2xl md:text-3xl font-serif font-bold text-white mb-1" data-id="element-586">
                  ¿Prefieres hacerlo solo?
                </h4>
                <h3 className="text-xl md:text-2xl font-serif font-bold text-inkova-accent mb-4" data-id="element-587">
                  Guía Digital — Ruta USA&nbsp;360
                </h3>

                <p className="text-gray-300 font-light leading-relaxed mb-6 max-w-lg" data-id="element-588">
                  Aprende paso a&nbsp;paso cómo crear tu empresa
                  en&nbsp;EE.&thinsp;UU. desde cero, con&nbsp;checklist,
                  requisitos reales y&nbsp;errores&nbsp;comunes.
                </p>

                <div className="mb-6 max-w-lg" data-id="element-589">
                  <h5 className="text-sm font-bold text-inkova-accent uppercase tracking-wider mb-3" data-id="element-590">
                    ¿Para quién es esta guía?
                  </h5>
                  <ul className="space-y-2" data-id="element-591">
                    <li className="flex items-start text-sm text-gray-300 font-light" data-id="element-592">
                      <span className="text-[#C9A84C] mr-2 flex-shrink-0" data-id="element-593">
                        ✔
                      </span>
                      Si ya has investigado, pero aún tienes&nbsp;dudas.
                    </li>
                    <li className="flex items-start text-sm text-gray-300 font-light" data-id="element-594">
                      <span className="text-[#C9A84C] mr-2 flex-shrink-0" data-id="element-595">
                        ✔
                      </span>
                      Si quieres asegurarte de hacerlo&nbsp;bien.
                    </li>
                    <li className="flex items-start text-sm text-gray-300 font-light" data-id="element-596">
                      <span className="text-[#C9A84C] mr-2 flex-shrink-0" data-id="element-597">
                        ✔
                      </span>
                      Si necesitas ordenar la información y avanzar
                      con&nbsp;seguridad.
                    </li>
                  </ul>
                </div>

                <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start mb-6" data-id="element-598">
                  <a href="https://inkovacreation.store/shop/0de4a31b-dafb-4911-b0f5-64f146eb7e48" target="_blank" rel="noopener noreferrer" className="inline-flex justify-center items-center px-8 py-3.5 rounded-xl bg-inkova-accent text-inkova-primary font-bold text-base hover:bg-white transition-colors duration-300 shadow-lg" data-id="element-599">
                    Descargar Guía — $33
                  </a>
                  <a href="https://wa.me/17863037695" target="_blank" rel="noopener noreferrer" className="inline-flex justify-center items-center px-8 py-3.5 rounded-xl border-2 border-white/30 text-white font-medium text-base hover:bg-white/10 transition-colors duration-300" data-id="element-600">
                    Prefiero que Inkova lo&nbsp;haga por&nbsp;mí
                  </a>
                </div>

                <p className="text-xs text-gray-400 italic" data-id="element-601">
                  ¿Sientes que puedes perder tiempo o&nbsp;cometer errores
                  en&nbsp;el&nbsp;proceso? Contáctanos y&nbsp;lo&nbsp;hacemos
                  correctamente por&nbsp;ti.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}